import { render, staticRenderFns } from "./ShareDiv.vue?vue&type=template&id=6b87d948&scoped=true&"
import script from "./ShareDiv.vue?vue&type=script&lang=js&"
export * from "./ShareDiv.vue?vue&type=script&lang=js&"
import style0 from "./ShareDiv.vue?vue&type=style&index=0&id=6b87d948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87d948",
  null
  
)

export default component.exports